import * as React from 'react';

import GLImageFilter from '../../../../shared/GLImageFilter';

import {
  backgroundImageUrl,
  BACKGROUND_FILTER_KEY_TO_BLOB,
} from '../../../../../helpers/images';

import BackgroundShowCommand from '../../../../../../domain/entities/commands/BackgroundShowCommand';

interface Size {
  height: number;
  width: number;
}

export interface Props {
  command: BackgroundShowCommand | null;
  size: Size;
  onAfterRenderBackground: (command: BackgroundShowCommand) => void;
}

export default class BackgroundShowCommandView extends React.Component<Props> {
  public render(): React.ReactNode {
    const {command, size} = this.props;
    if (!command) {
      return null;
    }
    const {background, options} = command;
    const filteredUri =
      BACKGROUND_FILTER_KEY_TO_BLOB[`${background.id}/${options.filter}`];
    const uri = backgroundImageUrl(background, size);
    return (
      <GLImageFilter
        key={command.getKey()}
        size={size}
        uri={filteredUri || uri}
        filter={filteredUri ? undefined : options.filter}
        onLoad={this.onLoad}
      />
    );
  }

  private onLoad = () => {
    const {command, onAfterRenderBackground} = this.props;
    if (command) {
      onAfterRenderBackground(command);
    }
  };
}
